import React, { useMemo } from 'react';
import MirsTable from 'components/general/table/Table.js';
import { findArray } from 'helpers/utils';
import { ColumnBib, ColumnNameH2H } from "components/common/TableColumns"
import { NocMemo as Noc } from 'components/presentation/Noc';
import Competitor from 'components/presentation/Competitor';
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";
import { useViewport } from 'components/general/useViewPort'

function Bk3PlayerStats({ data, team }) {
  const { mirs_rsc, mirs_competition } = useUrlFriendlyToParameters()
  let athletes = findArray(data?.results?.items, { startSortOrder: [team] })?.teamAthletes;
  let teamTotal = findArray(data?.results?.items, { startSortOrder: [team] })?.statsItems;

  let statsArray = ['PTS', 'P_VAL', 'S_EFF', 'P1', 'FT', 'P2', 'HGL', 'ASSIST', 'DRV', 'BLC', 'BZR', 'DNK', 'REB/', 'TO', 'OR', 'DR', 'PLUS_MINUS'];
  let items = statsArray.map((item) => {
    let itemStat = item.split('/');
    let val;
    let extendedVal;
    if (itemStat.length === 1) {
      val = findArray(teamTotal, { code: [itemStat[0]] })
    } else {
      val = findArray(teamTotal, { code: [itemStat[0]] })
      extendedVal = val.extendedStatsItems
    }

    return {
      code: itemStat[0], value: val?.value, attempt: val?.attempt, percent: val?.percent,
      extendedStatsItems: extendedVal
    }
  })

  let extra2 = {
    athlete: { code: '100001' },
    bib: 100001,
    title: <span className='fw-bold'>Totals</span>,
    statsItems:
      items,
  }
  let rebounds = findArray(teamTotal, { code: ['TREB'] })
  let reboundsDR = findArray(rebounds.extendedStatsItems, { code: ['DR'] }).value
  let reboundsOR = findArray(rebounds.extendedStatsItems, { code: ['OR'] }).value
  let TREB = rebounds.value
  let extra1 = {
    athlete: { code: '100000' },
    bib: 100000,
    title: 'Team',

    statsItems: [
      {
        code: 'REB', value: TREB, extendedStatsItems: [
          { code: 'OR', value: reboundsOR },
          { code: 'DR', value: reboundsDR }
        ]
      },
      { code: 'TO', value: findArray(teamTotal, { code: ['TTO'] })?.value },
      { code: 'PF', value: findArray(teamTotal, { code: ['PF_COACH'] })?.value }
    ]
  }

  //Before to inser check if exist yet

  athletes = athletes?.filter(item => item.code !== 100000 && item.code !== 100001)

  athletes.push(extra1)
  athletes.push(extra2)

  let competitorNoc = findArray(data?.results?.items, { startSortOrder: [team] })?.participant?.organisation?.code;
  let competitorName = findArray(data?.results?.items, { startSortOrder: [team] })?.participant?.name;
  let competitorCode = findArray(data?.results?.items, { startSortOrder: [team] })?.participant?.code;
  let participant = findArray(data?.results?.items, { startSortOrder: [team] })?.participant;

  const tableColumnsOG_SM = useMemo(() =>
    [
      ColumnBib({ disableSort: true, label: 'HeaderNumber', expecialCase: true }),
      ColumnNameH2H({ showStarter: false, hideNoc: true }),
      {
        id: 'PlayerStatsMIN',
        Header: "MIN",
        headerClassName: "text-end",
        className: 'text-end w-5',
        isVisible: false,
        columnIndex: 1,
        Cell: (props) => (
          findArray(props.cell.row.original.statsItems, { code: ['MINS'] }).value
        )
      },
      {
        id: 'PlayerStatsPTS',
        Header: "PTS",
        headerClassName: "text-end",
        className: 'text-end w-5',
        isVisible: false,
        columnIndex: 2,
        Cell: (props) => {
          return (
            <>
              {findArray(props.cell.row.original.statsItems, { code: ['PTS'] }).value}
            </>
          )
        }
      },
      {
        id: 'PlayerStatsP_VAL',
        Header: "P-VAL",
        headerClassName: "text-end",
        className: 'text-end w-5',
        isVisible: false,
        columnIndex: 3,
        Cell: (props) => {
          return (
            <>
              {findArray(props.cell.row.original.statsItems, { code: ['P_VAL'] }).value}
            </>
          )
        }
      },
      {
        id: 'PlayerStatsS_EFF',
        Header: "S-EFF",
        headerClassName: "text-end",
        className: 'text-end w-5',
        isVisible: false,
        columnIndex: 4,
        Cell: (props) => {
          return (
            <>
              {findArray(props.cell.row.original.statsItems, { code: ['S_EFF'] }).value}
            </>
          )
        }
      },
      {
        id: 'PlayerStatsP1',
        Header: "1PT",
        headerClassName: "text-end",
        className: 'text-end w-5',
        isVisible: false,
        columnIndex: 5,
        Cell: (props) => {
          let value = findArray(props.cell.row.original.statsItems, { code: ['P1'] }).value;
          let attempt = findArray(props.cell.row.original.statsItems, { code: ['P1'] }).attempt;
          let percent = findArray(props.cell.row.original.statsItems, { code: ['P1'] }).percent;
          return (
            <><PlayerStatsType value={value} attempt={attempt} percent={percent} /></>
          )
        }
      },
      {
        id: 'PlayerStatsFT',
        Header: "FT",
        headerClassName: "text-end",
        className: 'text-end w-5',
        isVisible: false,
        columnIndex: 6,
        Cell: (props) => {
          let value = findArray(props.cell.row.original.statsItems, { code: ['FT'] }).value;
          let attempt = findArray(props.cell.row.original.statsItems, { code: ['FT'] }).attempt;
          let percent = findArray(props.cell.row.original.statsItems, { code: ['FT'] }).percent;
          return (
            <><PlayerStatsType value={value} attempt={attempt} percent={percent} /></>
          )
        }
      },
      {
        id: 'PlayerStatsP2',
        Header: "2PT",
        headerClassName: "text-end",
        className: 'text-end w-5',
        isVisible: false,
        columnIndex: 7,
        Cell: (props) => {
          let value = findArray(props.cell.row.original.statsItems, { code: ['P2'] }).value;
          let attempt = findArray(props.cell.row.original.statsItems, { code: ['P2'] }).attempt;
          let percent = findArray(props.cell.row.original.statsItems, { code: ['P2'] }).percent;
          return (
            <><PlayerStatsType value={value} attempt={attempt} percent={percent} /></>
          )
        }
      },
      {
        id: 'PlayerStatsHGL',
        Header: "REB",
        headerClassName: "text-end",
        className: 'text-end w-5',
        isVisible: false,
        columnIndex: 8,
        Cell: (props) => {
          return (
            <>
              {findArray(props.cell.row.original.statsItems, { code: ['REB'] }).value}
            </>
          )
        }
      },
      {
        id: 'PlayerStatsKAS',
        Header: "KAS",
        headerClassName: "text-end",
        className: 'text-end w-5',
        isVisible: false,
        columnIndex: 9,
        Cell: (props) => {
          return (
            <>
              {findArray(props.cell.row.original.statsItems, { code: ['ASSIST'] }).value}
            </>
          )
        }
      },
      {
        id: 'PlayerStatsDRV',
        Header: "DRV",
        headerClassName: "text-end",
        className: 'text-end w-5',
        isVisible: false,
        columnIndex: 10,
        Cell: (props) => {
          return (
            <>
              {findArray(props.cell.row.original.statsItems, { code: ['DRV'] }).value}
            </>
          )
        }
      },
      {
        id: 'PlayerStatsBS',
        Header: "BS",
        headerClassName: "text-end",
        className: 'text-end w-5',
        isVisible: false,
        columnIndex: 11,
        Cell: (props) => {
          return (
            <>
              {findArray(props.cell.row.original.statsItems, { code: ['BLC'] }).value}
            </>
          )
        }
      },
      {
        id: 'PlayerStatsBZR',
        Header: "BZR",
        headerClassName: "text-end",
        className: 'text-end w-5',
        isVisible: false,
        columnIndex: 17,
        Cell: (props) => {
          return (
            <>
              {findArray(props.cell.row.original.statsItems, { code: ['BZR'] }).value}
            </>
          )
        }
      },
      {
        id: 'PlayerStatsDNK',
        Header: "DNK",
        headerClassName: "text-end",
        className: 'text-end w-5',
        isVisible: false,
        columnIndex: 13,
        Cell: (props) => {
          return (
            <>
              {findArray(props.cell.row.original.statsItems, { code: ['DNK'] }).value}
            </>
          )
        }
      },
      {
        id: 'PlayerStatsOR',
        Header: "OREB",
        headerClassName: "text-end",
        className: 'text-end w-5',
        isVisible: false,
        columnIndex: 15,
        Cell: (props) => {
          let rebounds = findArray(props.cell.row.original.statsItems, { code: ['REB'] })
          let reboundsValue = findArray(rebounds.extendedStatsItems, { code: ['OR'] }).value
          return reboundsValue
        }
      },
      {
        id: 'PlayerStatsDR',
        Header: "DREB",
        headerClassName: "text-end",
        className: 'text-end w-5',
        isVisible: false,
        columnIndex: 16,
        Cell: (props) => {
          let rebounds = findArray(props.cell.row.original.statsItems, { code: ['REB'] })
          let reboundsValue = findArray(rebounds.extendedStatsItems, { code: ['DR'] }).value
          return reboundsValue
        }
      },
      {
        id: 'PlayerStatsTO',
        Header: "TO",
        headerClassName: "text-end",
        className: 'text-end w-5',
        isVisible: false,
        columnIndex: 14,
        Cell: (props) => {
          return (
            <>
              {findArray(props.cell.row.original.statsItems, { code: ['TO'] }).value}
            </>
          )
        }
      },
      {
        id: 'PlayerStatsPLUS_MINUS',
        Header: "+/-",
        headerClassName: "text-end",
        className: 'text-end w-5',
        isVisible: false,
        columnIndex: 17,
        Cell: (props) => {
          return (
            <>
              {findArray(props.cell.row.original.statsItems, { code: ['PLUS_MINUS'] }).value}
            </>
          )
        }
      },
    ], []
  )

  const tableColumnsOG = useMemo(() =>
    [
      ColumnBib({ disableSort: true, label: 'HeaderNumber', expecialCase: true }),
      ColumnNameH2H({ showStarter: false }),
      {
        id: 'PlayerStatsMIN',
        Header: "MIN",
        headerClassName: "text-end",
        className: 'text-end w-5',
        isVisible: false,
        columnIndex: 1,
        Cell: (props) => (
          findArray(props.cell.row.original.statsItems, { code: ['MINS'] }).value
        )
      },
      {
        id: 'PlayerStatsPTS',
        Header: "PTS",
        headerClassName: "text-end",
        className: 'text-end w-5',
        isVisible: false,
        columnIndex: 2,
        Cell: (props) => {
          return (
            <>
              {findArray(props.cell.row.original.statsItems, { code: ['PTS'] }).value}
            </>
          )
        }
      },
      {
        id: 'PlayerStatsP_VAL',
        Header: "P-VAL",
        headerClassName: "text-end",
        className: 'text-end w-5',
        isVisible: false,
        columnIndex: 3,
        Cell: (props) => {
          return (
            <>
              {findArray(props.cell.row.original.statsItems, { code: ['P_VAL'] }).value}
            </>
          )
        }
      },
      {
        id: 'PlayerStatsS_EFF',
        Header: "S-EFF",
        headerClassName: "text-end",
        className: 'text-end w-5',
        isVisible: false,
        columnIndex: 4,
        Cell: (props) => {
          return (
            <>
              {findArray(props.cell.row.original.statsItems, { code: ['S_EFF'] }).value}
            </>
          )
        }
      },
      {
        id: 'PlayerStatsP1',
        Header: "1PT",
        headerClassName: "text-end",
        className: 'text-end w-5',
        isVisible: false,
        columnIndex: 5,
        Cell: (props) => {
          let value = findArray(props.cell.row.original.statsItems, { code: ['P1'] }).value;
          let attempt = findArray(props.cell.row.original.statsItems, { code: ['P1'] }).attempt;
          let percent = findArray(props.cell.row.original.statsItems, { code: ['P1'] }).percent;
          return (
            <><PlayerStatsType value={value} attempt={attempt} percent={percent} /></>
          )
        }
      },
      {
        id: 'PlayerStatsFT',
        Header: "FT",
        headerClassName: "text-end",
        className: 'text-end w-5',
        isVisible: false,
        columnIndex: 6,
        Cell: (props) => {
          let value = findArray(props.cell.row.original.statsItems, { code: ['FT'] }).value;
          let attempt = findArray(props.cell.row.original.statsItems, { code: ['FT'] }).attempt;
          let percent = findArray(props.cell.row.original.statsItems, { code: ['FT'] }).percent;
          return (
            <><PlayerStatsType value={value} attempt={attempt} percent={percent} /></>
          )
        }
      },
      {
        id: 'PlayerStatsP2',
        Header: "2PT",
        headerClassName: "text-end",
        className: 'text-end w-5',
        isVisible: false,
        columnIndex: 7,
        Cell: (props) => {
          let value = findArray(props.cell.row.original.statsItems, { code: ['P2'] }).value;
          let attempt = findArray(props.cell.row.original.statsItems, { code: ['P2'] }).attempt;
          let percent = findArray(props.cell.row.original.statsItems, { code: ['P2'] }).percent;
          return (
            <><PlayerStatsType value={value} attempt={attempt} percent={percent} /></>
          )
        }
      },
      {
        id: 'PlayerStatsHGL',
        Header: "REB",
        headerClassName: "text-end",
        className: 'text-end w-5',
        isVisible: false,
        columnIndex: 8,
        Cell: (props) => {
          return (
            <>
              {findArray(props.cell.row.original.statsItems, { code: ['REB'] }).value}
            </>
          )
        }
      },
      {
        id: 'PlayerStatsKAS',
        Header: "KAS",
        headerClassName: "text-end",
        className: 'text-end w-5',
        isVisible: false,
        columnIndex: 9,
        Cell: (props) => {
          return (
            <>
              {findArray(props.cell.row.original.statsItems, { code: ['ASSIST'] }).value}
            </>
          )
        }
      },
      {
        id: 'PlayerStatsDRV',
        Header: "DRV",
        headerClassName: "text-end",
        className: 'text-end w-5',
        isVisible: false,
        columnIndex: 10,
        Cell: (props) => {
          return (
            <>
              {findArray(props.cell.row.original.statsItems, { code: ['DRV'] }).value}
            </>
          )
        }
      },
      {
        id: 'PlayerStatsBS',
        Header: "BS",
        headerClassName: "text-end",
        className: 'text-end w-5',
        isVisible: false,
        columnIndex: 11,
        Cell: (props) => {
          return (
            <>
              {findArray(props.cell.row.original.statsItems, { code: ['BLC'] }).value}
            </>
          )
        }
      },
      {
        id: 'PlayerStatsBZR',
        Header: "BZR",
        headerClassName: "text-end",
        className: 'text-end w-5',
        isVisible: false,
        columnIndex: 12,
        Cell: (props) => {
          return (
            <>
              {findArray(props.cell.row.original.statsItems, { code: ['BZR'] }).value}
            </>
          )
        }
      },
      {
        id: 'PlayerStatsDNK',
        Header: "DNK",
        headerClassName: "text-end",
        className: 'text-end w-5',
        isVisible: false,
        columnIndex: 13,
        Cell: (props) => {
          return (
            <>
              {findArray(props.cell.row.original.statsItems, { code: ['DNK'] }).value}
            </>
          )
        }
      },
      {
        id: 'PlayerStatsOR',
        Header: "OREB",
        headerClassName: "text-end",
        className: 'text-end w-5',
        isVisible: false,
        columnIndex: 15,
        Cell: (props) => {
          let rebounds = findArray(props.cell.row.original.statsItems, { code: ['REB'] })
          let reboundsValue = findArray(rebounds.extendedStatsItems, { code: ['OR'] }).value
          return reboundsValue
        }
      },
      {
        id: 'PlayerStatsDR',
        Header: "DREB",
        headerClassName: "text-end",
        className: 'text-end w-5',
        isVisible: false,
        columnIndex: 16,
        Cell: (props) => {
          let rebounds = findArray(props.cell.row.original.statsItems, { code: ['REB'] })
          let reboundsValue = findArray(rebounds.extendedStatsItems, { code: ['DR'] }).value
          return reboundsValue
        }
      },
      {
        id: 'PlayerStatsTO',
        Header: "TO",
        headerClassName: "text-end",
        className: 'text-end w-5',
        isVisible: false,
        columnIndex: 14,
        Cell: (props) => {
          return (
            <>
              {findArray(props.cell.row.original.statsItems, { code: ['TO'] }).value}
            </>
          )
        }
      },
      {
        id: 'PlayerStatsPLUS_MINUS',
        Header: "+/-",
        headerClassName: "text-end",
        className: 'text-end w-5',
        isVisible: false,
        columnIndex: 17,
        Cell: (props) => {
          return (
            <>
              {findArray(props.cell.row.original.statsItems, { code: ['PLUS_MINUS'] }).value}
            </>
          )
        }
      },
    ], []
  )


  const tableColumnsEG_SM = useMemo(() =>
    [
      ColumnBib({ disableSort: true, label: 'HeaderNumber', expecialCase: true }),
      ColumnNameH2H({ showStarter: false, hideNoc: true }),
      {
        id: 'PlayerStatsMIN',
        Header: "MIN",
        headerClassName: "text-end",
        className: 'text-end w-5',
        isVisible: false,
        columnIndex: 1,
        Cell: (props) => (
          findArray(props.cell.row.original.statsItems, { code: ['MINS'] }).value
        )
      },
      {
        id: 'PlayerStatsPTS',
        Header: "PTS",
        headerClassName: "text-end",
        className: 'text-end w-5',
        isVisible: false,
        columnIndex: 2,
        Cell: (props) => {
          return (
            <>
              {findArray(props.cell.row.original.statsItems, { code: ['PTS'] }).value}
            </>
          )
        }
      },
      {
        id: 'PlayerStatsP1',
        Header: "1PT",
        headerClassName: "text-end",
        className: 'text-end w-5',
        isVisible: false,
        columnIndex: 3,
        Cell: (props) => {
          let value = findArray(props.cell.row.original.statsItems, { code: ['P1'] }).value;
          let attempt = findArray(props.cell.row.original.statsItems, { code: ['P1'] }).attempt;
          let percent = findArray(props.cell.row.original.statsItems, { code: ['P1'] }).percent;
          return (
            <><PlayerStatsType value={value} attempt={attempt} percent={percent} /></>
          )
        }
      },
      {
        id: 'PlayerStatsFT',
        Header: "FT",
        headerClassName: "text-end",
        className: 'text-end w-5',
        isVisible: false,
        columnIndex: 4,
        Cell: (props) => {
          let value = findArray(props.cell.row.original.statsItems, { code: ['FT'] }).value;
          let attempt = findArray(props.cell.row.original.statsItems, { code: ['FT'] }).attempt;
          let percent = findArray(props.cell.row.original.statsItems, { code: ['FT'] }).percent;
          return (
            <><PlayerStatsType value={value} attempt={attempt} percent={percent} /></>
          )
        }
      },
      {
        id: 'PlayerStatsP2',
        Header: "2PT",
        headerClassName: "text-end",
        className: 'text-end w-5',
        isVisible: false,
        columnIndex: 5,
        Cell: (props) => {
          let value = findArray(props.cell.row.original.statsItems, { code: ['P2'] }).value;
          let attempt = findArray(props.cell.row.original.statsItems, { code: ['P2'] }).attempt;
          let percent = findArray(props.cell.row.original.statsItems, { code: ['P2'] }).percent;
          return (
            <><PlayerStatsType value={value} attempt={attempt} percent={percent} /></>
          )
        }
      },
    ], []
  )

  const tableColumnsEG = useMemo(() =>
    [
      ColumnBib({ disableSort: true, label: 'HeaderNumber', expecialCase: true }),
      ColumnNameH2H({ showStarter: false }),
      {
        id: 'PlayerStatsMIN',
        Header: "MIN",
        headerClassName: "text-end",
        className: 'text-end w-5',
        isVisible: false,
        columnIndex: 1,
        Cell: (props) => (
          findArray(props.cell.row.original.statsItems, { code: ['MINS'] }).value
        )
      },
      {
        id: 'PlayerStatsPTS',
        Header: "PTS",
        headerClassName: "text-end",
        className: 'text-end w-5',
        isVisible: false,
        columnIndex: 2,
        Cell: (props) => {
          return (
            <>
              {findArray(props.cell.row.original.statsItems, { code: ['PTS'] }).value}
            </>
          )
        }
      },
      {
        id: 'PlayerStatsP1',
        Header: "1PT",
        headerClassName: "text-end",
        className: 'text-end w-5',
        isVisible: false,
        columnIndex: 3,
        Cell: (props) => {
          let value = findArray(props.cell.row.original.statsItems, { code: ['P1'] }).value;
          let attempt = findArray(props.cell.row.original.statsItems, { code: ['P1'] }).attempt;
          let percent = findArray(props.cell.row.original.statsItems, { code: ['P1'] }).percent;
          return (
            <><PlayerStatsType value={value} attempt={attempt} percent={percent} /></>
          )
        }
      },
      {
        id: 'PlayerStatsFT',
        Header: "FT",
        headerClassName: "text-end",
        className: 'text-end w-5',
        isVisible: false,
        columnIndex: 4,
        Cell: (props) => {
          let value = findArray(props.cell.row.original.statsItems, { code: ['FT'] }).value;
          let attempt = findArray(props.cell.row.original.statsItems, { code: ['FT'] }).attempt;
          let percent = findArray(props.cell.row.original.statsItems, { code: ['FT'] }).percent;
          return (
            <><PlayerStatsType value={value} attempt={attempt} percent={percent} /></>
          )
        }
      },
      {
        id: 'PlayerStatsP2',
        Header: "2PT",
        headerClassName: "text-end",
        className: 'text-end w-5',
        isVisible: false,
        columnIndex: 5,
        Cell: (props) => {
          let value = findArray(props.cell.row.original.statsItems, { code: ['P2'] }).value;
          let attempt = findArray(props.cell.row.original.statsItems, { code: ['P2'] }).attempt;
          let percent = findArray(props.cell.row.original.statsItems, { code: ['P2'] }).percent;
          return (
            <><PlayerStatsType value={value} attempt={attempt} percent={percent} /></>
          )
        }
      },
    ], []
  )

  let _caption = <CaptionTeam competitorNoc={competitorNoc} participant={participant} />

  const { breakPoint } = useViewport();

  let columnsOG = (breakPoint === "sm" || breakPoint === "xs") ? tableColumnsOG_SM : tableColumnsOG
  let columnsEG = (breakPoint === "sm" || breakPoint === "xs") ? tableColumnsEG_SM : tableColumnsEG

  return (
    <>
      {mirs_competition === 'OG2024'
        ? <MirsTable
          id={`mirs-table-player-statistics-${team + '-' + mirs_rsc}-${competitorCode}`}
          caption={_caption}
          data={athletes}
          columns={columnsOG}
          keyRow={"athlete-code"}
          initialSortBy={[{ id: 'Bib', desc: false }]}
          colsExtendedVisible={(breakPoint === "sm" || breakPoint === "xs") ? '5,6,6' : '9,8'}
          showNavExtendedData={true}
          colIndex={1}
        />
        : <MirsTable
          id={`mirs-table-player-statistics-${team + '-' + mirs_rsc}-${competitorCode}`}
          caption={_caption}
          data={athletes}
          columns={columnsEG}
          keyRow={"athlete-code"}
          initialSortBy={[{ id: 'Bib', desc: false }]}
          colsExtendedVisible={(breakPoint === "sm" || breakPoint === "xs") ? '5,0' : '5,0'}
          showNavExtendedData={false}
          colIndex={1}
        />
      }

    </>
  );
}

export default Bk3PlayerStats;

function CaptionTeam({ competitorNoc, participant }) {
  return (
    <div className='d-flex align-items-center'>
      <div className='d-none d-md-block me-1'>
        <Noc {...participant?.organisation} />
      </div>
      <strong>
        <Competitor hidePicture={true} {...participant} />
      </strong>
    </div >
  )
}

function PlayerStatsType({ value, attempt, percent }) {
  if (value !== undefined && percent !== undefined) {
    return (
      <>
        {value}/{attempt}<br />{percent}%
      </>
    )
  }
  else if (value !== undefined) {
    return (
      <>
        {value}/{attempt}
      </>
    )
  }
}